<script setup lang="ts">
defineProps<{
  name: string,
  logout:() => void,
}>();
</script>

<template>
  <MenuDropdown
    items-class="right-0 mt-2 w-56 origin-top-right z-20"
    btn-aria-label="Profile menu"
  >
    <template #title>
      <div class="flex space-x-2 items-center">
        <IconCircle :icon="['fal', 'user']" class="text-(--ui-primary) border-(--ui-primary) bg-(--ui-primary-50)" />
        <div class="flex items-center space-x-1 text-(--ui-primary)">
          <div class="hidden lg:block text-sm capitalize">
            {{ name }}
          </div>
          <UiFaIcon
            :icon="['fal', 'chevron-down']"
            class="ml-2 -mr-1 h-5 w-5 "
          />
        </div>
      </div>
    </template>
    <template #items>
      <MenuDropdownItem>
        <template #default="args">
          <NuxtLink to="/profile" :class="args.buttonClass">
            <UiFaIcon
              :icon="['fal', 'edit']"
              :class="args.iconClass"
            />
            Edit
          </NuxtLink>
        </template>
      </MenuDropdownItem>
      <MenuDropdownItem :icon="['fal', 'person-to-door']" title="Logout" @click="logout" />
    </template>
  </MenuDropdown>
</template>
